export default "__VITE_ASSET__ziTqok0Q__"